import React, { useMemo, useRef, useState } from "react";
import styled from "styled-components";
import iconSuccess from "../../../../../assets/images/Event-2024/missing-success.png";
import iconTeamCode from "../../../../../assets/images/Event-2024/Group (2).png";
import iconSpeTeamCode from "../../../../../assets/images/Event-2024/Group 105.png";
import iconHead from "../../../../../assets/images/Event-2024/Group (5).png";
import iconOpenGift from "../../../../../assets/images/Event-2024/Frame 61.png";
import iconOpenGiftFireWorks from "../../../../../assets/images/Event-2024/Frame 61 (1).png";
import iconSuccessBtn from "../../../../../assets/images/Event-2024/image 78.png";
import iconCardD7 from "../../../../../assets/images/Event-2024/code-d7.png";
import { useNavigate } from "react-router";
import PATH from "../../../../../config/PATH";
import { ID_TAB_EVENT_NEW_YEAR } from "../../../../../helper/const";
import { useDispatch, useSelector } from "react-redux";
import {
  getCodeDetailNewYear2024,
  getReceiveCodeNewYear2024,
} from "../../../../../Redux/futures/event-new-year-noel/actions";
import { curStateAccount } from "../../../../../Redux/selector";
import { useTranslation } from "react-i18next";
import moment from "moment";

export default function Mission({ codeDetail = {}, setTotalNumberAddCode }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isLoading = useRef(false);
  const selectorAccount = useSelector(curStateAccount);
  const codeWinTime = codeDetail?.codeWinTime;
  const endReceiveTime = codeDetail?.endReceiveTime;
  const parsedCodeWinTime = moment(codeWinTime, "YYYY-MM-DD HH:mm:ss");
  const parsedendReceiveTime = moment(endReceiveTime, "YYYY-MM-DD HH:mm:ss");

  const missionDayly = [
    {
      id: 1,
      numberTeamcode: "+5",
      missionDay: "Day 1",
    },
    {
      id: 2,
      numberTeamcode: "+5",
      missionDay: "Day 2",
    },
    {
      id: 3,
      numberTeamcode: "+10",
      missionDay: "Day 3",
    },
    {
      id: 4,
      numberTeamcode: "+5",
      missionDay: "Day 4",
    },
    {
      id: 5,
      numberTeamcode: "+15",
      missionDay: "Day 5",
    },
    {
      id: 6,
      numberTeamcode: "+5",
      missionDay: "Day 6",
    },
  ];

  const handleReceiveCode = async () => {
    if (!selectorAccount.userInfo) {
      return;
    }
    if (isLoading.current === true) {
      return;
    }
    isLoading.current = true;
    await dispatch(getReceiveCodeNewYear2024());
    await dispatch(getCodeDetailNewYear2024());
    isLoading.current = false;
    let totalCode = 0;
    missionDayly.forEach((item) => {
      if (item.id === codeDetail?.numberStreak) {
        totalCode = item.numberTeamcode;
      }
    });
    setTotalNumberAddCode(totalCode);
  };
  const currentTime = moment();

  const handleCheckTimer = (time16h = null) => {
    if (!codeWinTime) {
      return;
    }

    const endReceiveTimeCheck = moment(endReceiveTime); //12h

    if (time16h) {
      if (parsedCodeWinTime.isAfter(currentTime)) {
        return true;
      }
    }

    if (endReceiveTimeCheck.isAfter(currentTime)) {
      // console.log("Hiện tại nhỏ hơn timeAdd trưa của ngày codeWinTime.");
      return true;
    }

    return false;
  };

  const mission = [
    {
      srcImg: iconOpenGift,
      title: `${t("event_new_year.unwrap_Christmas_Boxes")}`,
      type: codeDetail?.openGift,
      action: () => {
        navigate(
          `${PATH.EVENT_NEW_YEAR_CHRISTMAS}/${ID_TAB_EVENT_NEW_YEAR.christmasTree}`
        );
      },
    },
    {
      srcImg: iconOpenGiftFireWorks,
      classItem: "icon-phao",
      title: `${t("event_new_year.light_Up_Fireworks")}`,
      type: codeDetail?.pairingFirework,
      action: () => {
        navigate(
          `${PATH.EVENT_NEW_YEAR_CHRISTMAS}/${ID_TAB_EVENT_NEW_YEAR.gameFireworks}`
        );
      },
    },
  ];

  const isSuccessMissionToday =
    codeDetail?.openGift && codeDetail?.pairingFirework;

  return (
    <ContainerMission>
      <div className="container-missing-detail">
        <div className="item-detail">
          {missionDayly.map((item) => {
            if (+codeDetail?.numberStreak > item.id) {
              return (
                <div className="item-mission-container" key={item.id}>
                  <div className="item-mission">
                    <div className="mission-number">{item.numberTeamcode}</div>
                    <div className="img-mission">
                      <img className="success_icon" src={iconSuccess} alt="" />
                    </div>
                  </div>
                  <div className="mission-day">{item.missionDay}</div>
                </div>
              );
            }
            if (+codeDetail?.numberStreak === item.id) {
              return (
                <div className="item-mission-container" key={item.id}>
                  <div
                    className={`item-mission ${
                      isSuccessMissionToday && !codeDetail?.isReceivedToday
                        ? "item-mission-active"
                        : ""
                    }`}
                  >
                    <div
                      className={`mission-number ${
                        isSuccessMissionToday && !codeDetail?.isReceivedToday
                          ? "number-mission-active"
                          : ""
                      }`}
                    >
                      {item.numberTeamcode}
                    </div>
                    <div className="img-mission">
                      <img
                        src={
                          !codeDetail?.isReceivedToday
                            ? iconTeamCode
                            : iconSuccess
                        }
                        alt=""
                        className={`
                          ${
                            !codeDetail?.isReceivedToday
                              ? "img-mission-team"
                              : "success_icon"
                          }
                        `}
                      />
                    </div>
                  </div>
                  <div
                    className={`mission-day ${
                      isSuccessMissionToday ? "mission-day-active" : ""
                    }`}
                  >
                    ယနေ့
                  </div>
                </div>
              );
            }
            if (+codeDetail?.numberStreak < item.id) {
              return (
                <div className="item-mission-container" key={item.id}>
                  <div className="item-mission">
                    <div className="mission-number">{item.numberTeamcode}</div>
                    <div className="img-mission">
                      <img
                        src={iconTeamCode}
                        alt="s"
                        className="img-mission-team"
                      />
                    </div>
                  </div>
                  <div className="mission-day">{item.missionDay}</div>
                </div>
              );
            }
          })}
          <div className="item-mission-container">
            <div
              className={`item-mission item_day_7 ${
                +codeDetail?.numberStreak === 7 && !codeDetail?.isReceivedToday
                  ? "item-mission-active"
                  : ""
              }`}
            >
              <img
                className={`card_7 ${
                  +codeDetail?.numberStreak === 7 && codeDetail?.isReceivedToday
                    ? "success_card_7"
                    : ""
                }`}
                src={
                  +codeDetail?.numberStreak === 7 && codeDetail?.isReceivedToday
                    ? iconSuccess
                    : iconCardD7
                }
                alt=""
              />
              <div
                className={`mission-number mission-number-speci ${
                  +codeDetail?.numberStreak === 7 ? "" : ""
                }`}
              >
                +20
              </div>
            </div>
            <div
              className={`mission-day ${
                +codeDetail?.numberStreak === 7 ? "mission-day-active" : ""
              }`}
            >
              {+codeDetail?.numberStreak === 7 ? "Now" : "Day 7"}
            </div>
          </div>
        </div>
      </div>
      <div className="container-special-task-detail">
        <div className="container-head-special">
          <div className="special-task-head">
            <img src={iconHead} alt="" className="first-icon-header" />
            <div className="title-special">
              {t("event_new_year.special_task")}
            </div>
            <img src={iconHead} alt="" className="last-icon-header" />
          </div>
          <div className="special-content-head">
            ယနေ့ {codeDetail?.numberCodeReceive || ""} အထူးcodeကိုရယူရန်
            လုပ်ဆောင်စရာကို ပြီးအောင်လုပ်ပါ။
          </div>
          <div
            className={`btn-success ${
              isSuccessMissionToday ? "success-mission" : ""
            }`}
          >
            ပြီးပြီ။&nbsp;
            {isSuccessMissionToday
              ? "2/2"
              : codeDetail?.openGift || codeDetail?.pairingFirework
              ? "1/2"
              : "0/2"}
            {/* {t("event_new_year.completed")} */}
            {/* Đã hoàn thành{" "}
            {isSuccessMissionToday
              ? "2"
              : codeDetail?.pairingFirework || codeDetail?.openGift
              ? 1
              : 0}
            /2 */}
          </div>
        </div>
        <div className="container-body-special-main">
          {mission.map((item, index) => {
            return (
              <div className="container-body-special" key={index}>
                <div className="body-special-item">
                  <img
                    src={item.srcImg}
                    alt=""
                    className={`icon-open-gift ${item.classItem || ""}`}
                  />
                  {!item.type ? (
                    <>
                      <div>
                        <div className="content-item">{item.title}</div>
                        {/* <div className="number-open" style={{height: "15px"}}></div> */}
                      </div>
                      <div className="btn-action" onClick={item.action}>
                        <div className="title-do-now">
                          {t("event_new_year.do_now")}
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      <div>
                        <div className="content-item">{item.title}</div>
                        {/* <div className="number-open number-open-success">
                          1/1
                        </div> */}
                      </div>
                      <div className="btn-action-success">
                        <img src={iconSuccessBtn} alt="" />
                        <div className="title-done">
                          {t("event_new_year.Done")}
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {handleCheckTimer() ? (
        codeDetail?.isReceivedToday ? ( // đã nhận hôm nay
          <div className={`btn-x-special-code disable-btn`}>
            <div className="btn-x-content">
              သင် {codeDetail?.numberCodeReceive} ကုဒ်များ လက်ခံရရှိပြီးဖြစ်သည်။
            </div>
          </div>
        ) : (
          <div
            onClick={handleReceiveCode}
            className={`btn-x-special-code  ${
              !codeDetail?.openGift ||
              !codeDetail?.pairingFirework ||
              codeDetail?.isReceivedToday
                ? "disable-btn"
                : ""
            }`}
          >
            <div
              className={`btn-x-content ${
                !codeDetail?.openGift ||
                !codeDetail?.pairingFirework ||
                codeDetail?.isReceivedToday
                  ? "disable-btn"
                  : ""
              }`}
            >
              {codeDetail?.numberCodeReceive || ""} အထူးcodeကို အခုပဲ
              ရယူလိုက်ပါ။
            </div>
          </div>
        )
      ) : (
        <div className={`btn-x-special-code disable-btn`}>
          <div className="btn-x-content">
            သင်သည် {codeDetail?.totalCode} ကုဒ်များကို
            လုံးဝလက်ခံရရှိပြီးဖြစ်သည်။
          </div>
        </div>
      )}

      {handleCheckTimer() && parsedCodeWinTime > currentTime ? ( // trước 12h 6/1
        <p className="text_bot">
          System မှ {parsedendReceiveTime?.format("HH:mm:ss")}{" "}
          {parsedendReceiveTime?.format("DD/MM/YYYY")} တွင်
          ကုဒ်များလက်ခံခြင်းကို ရပ်တန့်ပါမည်
        </p>
      ) : handleCheckTimer(true) && parsedCodeWinTime > currentTime ? ( // 12->16h 16/1
        <p className="text_bot">
          ယနေ့၊ {parsedendReceiveTime?.format("DD/MM/YYYY")} တွင်{" "}
          {parsedendReceiveTime?.format("HH:mm:ss")} တွင် ကုဒ်များ လက်ခံခြင်းကို
          System မှ ရပ်တန့်ပါမည်။
        </p>
      ) : (
        <p></p>
      )}
    </ContainerMission>
  );
}

const ContainerMission = styled.div`
  .text_bot {
    font-size: 12px;
    text-align: center;
    margin-top: 5px;
  }
  .icon-phao {
    max-width: 82px;
    width: 82px;
  }

  .disable-btn {
    /* pointer-events: none; */
    cursor: no-drop !important;
    opacity: 0.5 !important;
  }

  .mission-day-active {
    font-weight: 600 !important;
    color: black !important;
  }

  .number-mission-active {
    color: #047900 !important;
  }

  .btn-success.success-mission {
    background-color: rgba(114, 205, 0, 0.2);
    color: black;
    line-height: 22px;
    border: 1px solid #047900;
  }

  .number-open.number-open-success {
    background-color: #46af60;
    color: white;
  }

  .btn-x-special-code {
    width: 100%;
    height: 60px;
    background-color: #f97a1c;
    border: 1px solid #c76216;
    border-bottom: 4px solid #c76216;
    border-radius: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 15px;
    cursor: pointer;
  }

  .btn-x-content {
    color: white;
    font-size: 18px;
    font-weight: bold;
    filter: drop-shadow(1px 0 0 #c76216) drop-shadow(-1px 0 0 #c76216)
      drop-shadow(0 1px 0 #c76216) drop-shadow(0 -1px 0 #c76216);
  }

  .title-done {
    color: #079455;
    font-size: 16px;
    font-weight: bold;
  }

  .btn-action-success {
    background-color: rgba(7, 148, 85, 0.1);
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 12px;
    height: 44px;
    border-radius: 12px;
  }

  .title-do-now {
    filter: drop-shadow(1px 0 0 #236621) drop-shadow(-1px 0 0 #236621)
      drop-shadow(0 1px 0 #236621) drop-shadow(0 -1px 0 #236621);
  }

  .container-body-special-main {
    margin-top: 16px;
  }

  .btn-action {
    background-color: #17b26a;
    border-radius: 12px;
    height: 44px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    border: 1px solid #079455;
    border-bottom: 4px solid #079455;
    cursor: pointer;
  }

  .content-item {
    color: #1c1917;
    font-size: 16px;
    font-weight: bold;
  }

  .number-open {
    border: 1px solid #d7d3d0;
    background-color: #e7e5e4;
    border-radius: 12px;
    overflow: hidden;
    color: #79716b;
    text-align: center;
    line-height: 1;
    margin-top: 8px;
    padding: 1px 0;
  }

  .body-special-item {
    border-top: 1px dashed #ab9d92;
    padding: 16px 0;
    display: grid;
    grid-template-columns: 63px calc(100% - 63px - 128px - 40px) 128px;
    gap: 20px;
    align-items: center;
    justify-content: space-between;
  }

  .container-body-special {
    /* margin-top: 15px; */
    padding: 0 15px;
  }

  .container-head-special {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .btn-success {
    width: max-content;
    padding: 5px 30px;
    margin: 0 auto;
    border: 1px solid #f97a1c;
    background-color: #fdd7bb;
    color: #64310b;
    font-size: 14px;
    font-weight: 500;
    border-radius: 18px;
  }

  .special-content-head {
    text-align: center;
    color: rgba(87, 83, 78, 1);
    font-size: 16px;
  }
  .card_7 {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 8px;
    width: 80px;
  }
  .title-special {
    color: #64310b;
    font-size: 32px;
    font-weight: bold;
  }

  .first-icon-header {
    transform: rotate(-25.21deg);
  }

  .last-icon-header {
    transform: rotate(64.79deg);
  }

  .special-task-head {
    display: flex;
    gap: 5px;
    justify-content: center;
    align-items: center;
    padding: 20px 16px;
    padding-bottom: 0;
  }

  .container-special-task-detail {
    margin-top: 25px;
    background-color: #ebd4b2;
    border-radius: 16px;
  }

  .container-missing-detail {
    /* display: grid;
    grid-template-columns: calc(100% - 85px) 85px;
    gap: 5px; */
  }

  .img-mission-team {
    height: 68px;
  }

  .item-mission-container-bg {
    height: 115px;
    width: 100%;
    border-radius: 12px;
  }

  .item-detail {
    display: grid;
    gap: 5px;
    grid-template-columns: repeat(6, 1fr) 97px;
  }

  .mission-day {
    font-size: 14px;
    text-align: center;
    font-weight: 500;
    color: #87827e;
    padding-top: 5px;
  }

  .img-mission {
    display: flex;
    justify-content: center;
    align-items: center;
    height: calc(100% - 35px);
  }

  .item-mission {
    width: 100%;
    height: 115px;
    background-color: #ebd4b2;
    border-radius: 12px;
    position: relative;
  }

  .item-mission-active {
    background-color: rgba(114, 205, 0, 0.2);
    border: 1px solid #047900;
  }

  .item-mission-container {
    width: 100%;
  }

  .mission-number {
    padding-top: 20px;
    height: 34px;
    text-align: center;
    color: black;
    font-weight: bold;
    font-size: 16px;
  }

  .mission-number-speci {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 0;
    color: white;
  }
  .success_card_7 {
    width: 38px;
    bottom: 28px;
  }
  @media (max-width: 1440px) {
    .btn-x-content {
      font-size: 15px;
    }
    .special-content-head {
      font-size: 12px;
    }
  }
  @media (min-width: 992px) {
    .btn-x-special-code:hover {
      background-color: #b65409;
      border: 1px solid #6b370f;
      border-bottom: 4px solid #6b370f;
      transition: 0.3s ease-in-out;
    }

    .btn-action:hover {
      scale: 1.05;
      transition: 0.3s ease-in-out;
      opacity: 0.8;
    }
  }

  @media (max-width: 768px) {
    .title-special {
      font-size: 24px;
    }

    .special-content-head {
      font-size: 14px;
    }

    .btn-success {
      font-size: 13px;
    }
    .text_bot {
      padding-top: 15px;
    }
  }

  @media (max-width: 576px) {
    .success_icon {
      width: 25px;
      margin-top: 25px;
    }
    .item-detail {
      grid-template-columns: repeat(6, 1fr) 60px;
    }
    .card_7 {
      bottom: 10px;
    }
    .item-mission {
      height: 90px;
    }
    .title-do-now {
      font-size: 12px;
    }

    .body-special-item {
      gap: 12px;
    }
    .img-mission {
      height: max-content !important;
      padding-top: 0;
      margin-top: -2px;
    }
    .btn-x-special-code {
      margin-top: 25px !important;
    }
    .success_card_7 {
      width: 25px;
      bottom: 25px;
    }
  }
  @media (max-width: 420px) {
    .btn-x-content {
      font-size: 12px !important;
    }

    .success_icon {
      /* width: 25px; */
      padding: 0 3px;
      max-width: 25px;
      width: auto;
      margin-top: 15px;
    }

    .item-mission {
      height: 75px;
    }

    .card_7 {
      width: 40px;
    }

    .mission-day {
      font-size: 11px !important;
      width: max-content;
      margin: 0 auto;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .mission-number-speci {
      margin-top: 5px;
    }

    .img-mission-team {
      height: auto;
      width: 25px;
      margin-top: 8px;
    }

    .success_card_7 {
      bottom: 20px;
    }
  }
`;
